import { List, Map } from 'immutable';
import { REHYDRATE } from 'redux-persist/constants';

import { SearchActions, SearchKeys, SearchScopes } from './constants';
import * as D from './deps';

const INITIAL_STATE = Map({
  [SearchKeys.ADD_VARIETY_SEARCH]: Map({
    [SearchKeys.SEARCH_TERM]: '',
  }),
  [SearchKeys.FETCHED_SEARCH_RESULTS]: false,
  [SearchKeys.MAIN_SEARCH]: Map({
    [SearchKeys.SEARCH_TERM]: '',
    [SearchKeys.SEARCH_ACTIVE]: false,
  }),
  [SearchKeys.PLAYLIST_TRACK_SEARCH]: Map({
    [SearchKeys.SEARCH_TERM]: '',
  }),
  [SearchKeys.PREV_INDEX]: null,
  [SearchKeys.RECEIVED_RESULTS_IN_LAST_REQUEST]: false,
  [SearchKeys.SEARCH_FILTER]: SearchScopes.ALL,
  [SearchKeys.SEARCH_RESULTS_NUMS]: Map({}),
  [SearchKeys.SEARCH_RESULTS]: List([]),
  [SearchKeys.SEARCH_TOKEN]: null,
});

// SEARCH REDUCER
export default D.createReducer(INITIAL_STATE, {
  [REHYDRATE]: onRehydrate,
  [D.ApiActions.SOD_SEARCH_FAIL]: searchFail,
  [D.ApiActions.SOD_SEARCH_SUCCESS]: searchSuccess,
  [D.ApiActions.T3_SEARCH_TERM_UPDATE]: searchTermUpdate,
  [SearchActions.FILTER_CHANGED]: searchFilterChanged,
  [SearchActions.FULL_SEARCH]: searchAttempt,
  [SearchActions.RESET_RESULTS]: resetResults,
  [SearchActions.SEARCH_UI_UPDATE]: searchUiUpdate,
});

// CASE FUNCTIONS
function onRehydrate(state: $TSFixMe, action: $TSFixMe) {
  return state.mergeDeep(action.payload.search);
}

function searchTermUpdate(
  state: $TSFixMe,
  { payload: { searchTerm, searchType, searchFilter } }: $TSFixMe,
) {
  let newState = state.mergeDeep({
    [searchType]: Map({
      [SearchKeys.SEARCH_TERM]: searchTerm,
    }),
  });

  if (searchFilter) {
    newState = newState.set(SearchKeys.SEARCH_FILTER, searchFilter);
  }

  if (
    searchType === SearchKeys.MAIN_SEARCH &&
    state.get(SearchKeys.PLAYLIST_TRACK_SEARCH) &&
    state.get(SearchKeys.PLAYLIST_TRACK_SEARCH).get(SearchKeys.SEARCH_TERM)
  ) {
    newState = newState.setIn([SearchKeys.PLAYLIST_TRACK_SEARCH, SearchKeys.SEARCH_TERM], '');
  }

  if (
    searchType === SearchKeys.MAIN_SEARCH &&
    state.get(SearchKeys.ADD_VARIETY_SEARCH) &&
    state.get(SearchKeys.ADD_VARIETY_SEARCH).get(SearchKeys.SEARCH_TERM)
  ) {
    newState = newState.setIn([SearchKeys.ADD_VARIETY_SEARCH, SearchKeys.SEARCH_TERM], '');
  }

  return newState;
}

function searchAttempt(state: $TSFixMe) {
  return state.set(SearchKeys.FETCHED_SEARCH_RESULTS, false);
}

function searchFail(state: $TSFixMe) {
  return state.set(SearchKeys.FETCHED_SEARCH_RESULTS, true);
}

function searchSuccess(state: $TSFixMe, action: $TSFixMe) {
  const { query, start } = action.params.content;

  // we're checking the result against multiple conditions because the api responses from
  // various calls may be out-of-order, and we want to save the correct response
  const indexCond = state.get(SearchKeys.PREV_INDEX) !== start;
  const searchTermCond = state.getIn([action.params.searchType, SearchKeys.SEARCH_TERM]) === query;
  let totalCond = indexCond && searchTermCond;

  if (action.params.searchType === SearchKeys.MAIN_SEARCH) {
    const searchFilterPathCond = D.UrlUtils.getCurrentUrlPath().endsWith(
      action.params.searchFilter || '/all',
    );
    totalCond = totalCond && searchFilterPathCond;
  }

  if (totalCond) {
    const newResults =
      start === 0
        ? List(action.response.results)
        : state.get(SearchKeys.SEARCH_RESULTS).concat(action.response.results);

    const hadNewResults = !!action.response.results.length;
    D.Utils.Time.markTimeAtMomentForQuery(
      D.Constants.App.SearchCheckpointMarks.SEARCH_STATS_SOD_RESPONSE,
      query,
    );
    return state.merge({
      [SearchKeys.FETCHED_SEARCH_RESULTS]: true,
      [SearchKeys.PREV_INDEX]: start,
      [SearchKeys.RECEIVED_RESULTS_IN_LAST_REQUEST]: hadNewResults,
      [SearchKeys.SEARCH_RESULTS_NUMS]: Map(action.response.numResults),
      [SearchKeys.SEARCH_RESULTS]: newResults,
      [SearchKeys.SEARCH_TOKEN]: action.response[SearchKeys.SEARCH_TOKEN],
    });
  }
  return state;
}

function searchFilterChanged(state: $TSFixMe, { payload: { searchFilter } }: $TSFixMe) {
  return state.merge({
    [SearchKeys.SEARCH_FILTER]: searchFilter,
  });
}

function resetResults(state: $TSFixMe) {
  return state.merge({
    [SearchKeys.FETCHED_SEARCH_RESULTS]: false,
    [SearchKeys.PREV_INDEX]: null,
    [SearchKeys.RECEIVED_RESULTS_IN_LAST_REQUEST]: false,
    [SearchKeys.SEARCH_RESULTS_NUMS]: Map({}),
    [SearchKeys.SEARCH_RESULTS]: List([]),
  });
}

function searchUiUpdate(state: $TSFixMe, { payload }: $TSFixMe) {
  return state.mergeIn([payload.searchType], payload);
}
